<script lang="ts">
import { defineComponent } from 'vue'

export default defineComponent({
  name: 'domain'
})
</script>

<template>
<div class="custom-background" style="height: 90vh"></div>
</template>
